import { Injectable } from '@angular/core';

import {
  FilterState,
  FilterStateService,
  FilterStateValues,
} from './filter-state.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterStateService {
  filterState: FilterState[] = [];

  constructor(private filterStateService: FilterStateService) {}

  /**
   * Sets the given value for the given key on the filterState object.
   * @param name Name of the key to set the value of.
   * @param values The values to set.
   * @param inputType The type of input it is. Options: ```text```, ```simple-select```, ```checkbox```, ```custom-select```, ```date```, ```date-range```.
   * @param label The label text to to describe the filter.
   */
  setValue(
    name: string,
    values: FilterStateValues,
    inputType: string,
    label: string,
    isGlobal: boolean = false
  ): void {
    this.filterState[name] = {
      key: name,
      label: label,
      type: inputType,
      values: values,
      isGlobal: isGlobal,
    };
    this.filterStateService.setValue(name, values, inputType, label, isGlobal);
  }

  /**
   * Resets a filter key to nothing.
   * @param key String: They key to reset to nothing.
   */
  resetKey(key: string): void {
    delete this.filterState[key];
    this.filterStateService.resetKey(key);
  }
}
